import { Vue, Component, Watch } from "vue-property-decorator";
import { DispatchRequest, DispatchType } from "@/store/mobile/types";
@Component({})
export default class DispatchMixin extends Vue {

    public displayDispatchRequest(dispatchRequests: DispatchRequest[], OnlyCurrentTourStep: boolean = false) {
		let items = [];
		dispatchRequests.forEach(dispatchRequest => {
			if (dispatchRequest.dispatchType == DispatchType.Dispatch || !dispatchRequest.dispatchType) {
				dispatchRequest.isCurrentTourStep = null;
				items.push(dispatchRequest);
				return;
			}

			// If we can't find the item and this current dispatchRequest is a tour type,
			// it must be the current tour step
			if (items.findIndex(x => x.eventID == dispatchRequest.eventID) == -1
					&& this.isTourType(dispatchRequest.dispatchType)) {
				dispatchRequest.isCurrentTourStep = true;
				items.push(dispatchRequest);
			} else {
				if (OnlyCurrentTourStep) return;
				dispatchRequest.isCurrentTourStep = false;
				items.push(dispatchRequest);
			}
		});
		return items;
	}

	public DispatchRequestsCount(dispatchRequests: DispatchRequest[]) {
		if (!dispatchRequests) return 0;
		return this.displayDispatchRequest(dispatchRequests).filter(
			(dispatch: DispatchRequest) =>
			dispatch.dispatchType == DispatchType.Dispatch ||
			dispatch.dispatchType == DispatchType.Tour &&
			dispatch.isCurrentTourStep).length;
	}

	public parseLocationToLatLng(location: string): google.maps.LatLng {
		if (!location) {
			return new google.maps.LatLng(0, 0);
		}

		// Split the location string into a proper Google LatLng object
		let latlng = location.split(",");
		if (latlng.length < 2) {
			latlng = location.split(" ");
		}
		return new google.maps.LatLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
	}

	public isTourType(dispatchType: string): boolean {
        return dispatchType === DispatchType.Tour || dispatchType === DispatchType.Assessment;
    }

	public isAssessmentType(dispatchType: string): boolean {
		return dispatchType === DispatchType.Assessment;
	}

	public dispatchTypeBorderClasses(dispatchRequest: DispatchRequest) {
        return {
            "active-dispatch": dispatchRequest.active,
            "bd-color-primary": dispatchRequest.dispatchType === DispatchType.Dispatch,
            "bd-color-secondary": dispatchRequest.dispatchType === DispatchType.Tour,
            "bd-color-success": dispatchRequest.dispatchType === DispatchType.Assessment
        }
    }

	public dispatchTypeBackgroundClasses(dispatchRequest: DispatchRequest) {
        return {
            "bg-color-primary": dispatchRequest.dispatchType === DispatchType.Dispatch,
            "bg-color-secondary": dispatchRequest.dispatchType === DispatchType.Tour,
            "bg-color-success": dispatchRequest.dispatchType === DispatchType.Assessment
        }
    }

	public dispatchTypeIconClass(dispatchRequest: DispatchRequest) {
		switch(dispatchRequest.dispatchType) {
			case DispatchType.Dispatch:
				return "fas fa-walking text-primary";
			case DispatchType.Tour:
				return "fas fa-route text-secondary";
			case DispatchType.Assessment:
				return "fas fa-clipboard-list text-success";
		}
	}

	public getMarkerCircleColor(dispatchType: string) {
		switch (dispatchType) {
			case DispatchType.Tour:
				return "#F56A23"
			case DispatchType.Assessment:
				return "#74526C"
			case DispatchType.Dispatch:
				return "#117C8F";
			default:
				return "#117C8F";
		}
	}
}